import React, {useEffect, useState} from 'react';
import cl from '../styles/CoursesPage.module.css'
import CourseItem from "../components/UI/CourseItem/CourseItem";
import add from '../Assets/icons/course_add.svg'
import add_active from '../Assets/icons_active/course_add_active.svg'
import {useNavigate} from "react-router-dom";
import Service from "../API/Service";
import SearchAndFilter from "../components/UI/SearchAndFilter/SearchAndFilter";

const CoursesPage = () => {
    const navigate = useNavigate();
    const [isHovered, setIsHovered] = useState(false);
    const [courses, setCourses] = useState([]);
    const [filters, setFilters] = useState({
        searchText: "",
        departmentId: "",
        teacherId: "",
        status: "",
        startDate: "",
        endDate: "",
    })

    const entity = "courses";

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Service.getCourses(entity, filters);
                // console.log("New filters",filters);
                const content = response.data.content;
                setCourses(content);
                // setTotalPages(response.data.totalPages)
            } catch (error) {
                console.error("Ошибка при загрузке данных:", error);
                setCourses([]);
            }
        };
        fetchData();
    }, [filters]);


    return (
        <div className={cl.wrap}>
            <div className={cl.heading}>
                <h1>Courses</h1>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
            </div>
            <SearchAndFilter
                filters={filters}
                setFilters={setFilters}
                entity={entity}
            />
            <div className={cl.courseGrid}>
                <div
                    className={cl.courseAdd}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={() => navigate('/courses/add')}
                >
                    <img
                        src={isHovered ? add_active : add}
                        alt={"course add"}
                    />
                </div>
                {courses.map((course, index) => (
                    <CourseItem
                        key={index}
                        item={course}
                        setCourses={setCourses}
                    />
                ))}
            </div>
        </div>
    );
};

export default CoursesPage;